import { useSelector } from 'react-redux';
import { Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectHasFiber, selectUser } from '@app/redux/auth';

import { usePrepopulateContactInfo } from '../../hooks';

import styles from './index.module.scss';

const ReviewContactInformation = () => {
  const userInfo = useSelector(selectUser);
  const hasFiber = useSelector(selectHasFiber);

  const { t } = useTranslation('Disconnect');
  const { address, email } = usePrepopulateContactInfo();

  return (
    <Surface p="16px" radius="8px" variant="primary" className={styles['contactInfoCard']}>
      <Surface style={{ width: '100%' }}>
        <Txt variant="labelSmall" mb="4px">
          {t('step3.accountTitle')}
        </Txt>
        <Txt variant="bodySmallRegular">
          {t('step3.accountInfo')} {userInfo.user.accountNumber}
        </Txt>
      </Surface>

      {!hasFiber && (
        <div style={{ width: '100%' }}>
          <Txt variant="labelSmall" mb="4px">
            {t('step3.shippingAddress')}
          </Txt>
          <Txt variant="bodySmallRegular">{address[0]}</Txt>
          <Txt variant="bodySmallRegular">{address[1]}</Txt>
        </div>
      )}

      <div style={{ width: '100%' }}>
        <Txt variant="labelSmall" mb="4px">
          {t('step3.emailAddress')}
        </Txt>
        <Txt variant="bodySmallRegular">{email}</Txt>
      </div>
    </Surface>
  );
};

export default ReviewContactInformation;
